import { createAppAsyncThunk } from '@/domain/store.thunk';

export const setExternalInvitationCode = createAppAsyncThunk(
  'auth/setExternalInvitationCode',
  async (code: string, { extra: { authGateway } }) => {
    await authGateway.setExternalInvitationCode(code);
  },
);
